import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import Axios from 'axios';
import Card from 'app/containers/Card';
import { BsArrowRight } from 'react-icons/bs';
import { ToogleLinkButton } from 'app/components/ToogleLinkButton/ToogleLinkButton';
import { BUTTON } from 'app/components/ToogleLinkButton/models.d';
import Loader from 'app/components/Loader';
import Typography from 'app/components/Typography';
import { TYPOGRAPHY } from 'app/components/Typography/models.d';
import Container from 'app/layouts/layout/Container';
import { getInsights, InsightsI } from 'app/adapters/Insights';
import './RecentInsightsLists.scss';

const RecentInsightsLists = () => {
  const [recentInsightsLists, setRecentInsightsLists] = useState<InsightsI[]>(
    [],
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getInsightsData = async () => {
    try {
      const { data } = await getInsights({ limit: 6 });
      setRecentInsightsLists(data.results);
      setIsLoading(false);
    } catch (error) {
      if (!Axios.isCancel(error)) {
        message.error('An error occurred while fetching the insights data');
      }
    }
  };

  useEffect(() => {
    getInsightsData();
  }, []);

  return (
    <Container className={'recent-insights-lists-wrapper'} maxWidth="XL">
      <Typography
        variant={TYPOGRAPHY.VARIANT.H3}
        size={TYPOGRAPHY.SIZE.HUGE}
        className="recent-insights-lists__title"
      >
        RECENT INSIGHTS
      </Typography>
      <div className="recent-insights-lists">
        {!isLoading ? (
          recentInsightsLists?.map((insight, index) => (
            <Card
              recentInsightsProps={{
                title: insight.name,
                description: insight.content,
                link: insight.page_url,
              }}
              key={index}
            />
          ))
        ) : (
          <Loader />
        )}
      </div>
      <div className="recent-insights-lists__btn">
        <ToogleLinkButton
          version={BUTTON.VERSION.INTERNAL_LINK}
          variant={BUTTON.VARIANT.OUTLINE}
          color={BUTTON.COLOR.GRAY}
          size={BUTTON.SIZE.BIG}
          round={BUTTON.ROUND.MEDIUM_LIGHT}
          AppendChild={<BsArrowRight />}
          link={`/insights`}
        >
          More Insights
        </ToogleLinkButton>
      </div>
    </Container>
  );
};

export default RecentInsightsLists;
